module.exports = __webpack_public_path__ + "img/history.476749e5.jpg";